import { catVarietyList } from "./catVarietyList";
import { dogVarietyList } from "./dogVarietyList";

export const petVarietyList = {
  cat: catVarietyList,
  dog: dogVarietyList,
};
